import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { DividendsSettingsState, ModelDividend } from './DividendsSettingsState';
import { EventId, MarketId } from 'src_common/common/websocket2/id/WebsocketId';

interface DividendModelPropsType {
    model: ModelDividend,
}

const DividendModel = observer('DividendModel', (props: DividendModelPropsType): React.ReactElement => {
    const { model } = props;

    const disabledClass = model.isChange ? '' : 'disabled';

    return (
        <tr key={ model.id }>
            <td>{ model.type === 'forecast' ? 'Forecast' : 'Tricast' }</td>
            <td className='element'>
                <select
                    value={ model.valueWinner ?? undefined }
                    onChange={ (e): void => model.setWinner(e.target.value) }
                >
                    <option />
                    {
                        model.selectionsWinner.map(s => (
                            <option
                                key={ s.id }
                                value={ s.id }
                            >
                                { s.name }
                            </option>
                        ))
                    }
                </select>
            </td>
            <td className='element'>
                <select
                    value={ model.value2nd }
                    onChange={(e): void => model.set2nd(e.target.value) }
                >
                    <option />
                    {
                        model.selections2nd.map(s => (
                            <option
                                key={ s.id }
                                value={ s.id }
                            >
                                { s.name }
                            </option>
                        ))
                    }
                </select>
            </td>
            <td className='element'>
                {
                    model.type === 'tricast' ? (
                        <select
                            value={ model.value3rd }
                            onChange={(e): void => model.set3rd(e.target.value) }
                        >
                            <option />
                            {
                                model.selections3rd.map(s => (
                                    <option
                                        key={ s.id }
                                        value={ s.id }
                                    >
                                        { s.name }
                                    </option>
                                ))
                            }
                        </select>
                    ) : '-'
                }
            </td>
            <td className='element'>
                <input
                    type='text'
                    value={ model.valueDividend }
                    onChange={(e): void => model.setDividend(e.target.value) }
                />
            </td>
            <td>
                <a href='#' className={`btn ${disabledClass}`} onClick={
                    (e): void => {
                        e.preventDefault();
                        model.saveOrAdd().catch((error) => {
                            console.error(error);
                        });
                    }
                }>{ model.buttonLabel }</a>
            </td>
        </tr>
    );
});

interface PropsType {
    eventId: EventId,
    marketId: MarketId,
}

export const DividendsSettings = observer('DividendsSettings', (props: PropsType) => {
    const [dividendsSettingsState] = React.useState(() => new DividendsSettingsState(
        props.eventId,
        props.marketId,
    ));

    const forecastsOffered = dividendsSettingsState.forecastsOffered;
    const tricastsOffered = dividendsSettingsState.tricastsOffered;

    return (
        <div className='dividends-settings'>
            <table className='form'>
                <thead>
                    <tr>
                        <th><strong>Dividend</strong></th>
                        <th>Winner</th>
                        <th>2nd</th>
                        <th>3rd</th>
                        <th>Dividend</th>
                        <th>
                            {
                                forecastsOffered ?
                                    <a href='#' className='btn btn-add' onClick={
                                        (): void => dividendsSettingsState.add('forecast')
                                    }>
                                        Add Forecast
                                    </a> :
                                    undefined
                            }
                            {
                                tricastsOffered ?
                                    <a href='#' className='btn btn-add' onClick={
                                        (): void => dividendsSettingsState.add('tricast')
                                    }>
                                        Add Tricast
                                    </a> :
                                    undefined
                            }
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        dividendsSettingsState.listForView().map((model) => (
                            <DividendModel
                                key={model.id}
                                model={model}
                            />
                        ))
                    }
                </tbody>
            </table>
        </div>
    );
});
